import React, { useContext, useEffect, useState } from "react";
import { AgricSvg } from "../svg/AgricSvg";
import TestNav from "../components/TestNav";
import testImg from "../images/test.png";
import { TimeSvg } from "../svg/TimeSvg";
import { QuestionsSvg } from "../svg/QuestionsSvg";
import Card from "../components/common/Card";
import Button from "../components/common/Button";
import { useHistory } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import Sidebar from "../components/Sidebar";
import FooterNav from "../components/FooterNav";
import { toTitleCase } from "../util/titleCase";
import axios from "axios";
// container60

const CbtTest = () => {
  const [questionsLength, setQuestionsLength] = useState([]);
  const [fetchError, setFetchError] = useState("");

  const history = useHistory();
  const dataContext = useContext(DataContext);
  const showMenu = dataContext.showMenu;
  const studentInfo = JSON.parse(localStorage.getItem("studentInfo"));
  const admissionnumber = studentInfo[0].admissionnumber;
  // const schoolDomain = window.location.host;
  const schoolDomain = localStorage.getItem("schoolDomain");

  useEffect(() => {
    const cbtDataBody = {
      SchoolUrl: schoolDomain,
      //   examidx: dataContext.clickedCbtItem.idx,
      examidx: JSON.parse(localStorage.getItem("clickedCbtItem")).idx,
      admissionnumber,
    };
    const getCbtExamQuestions = async () => {
      try {
        const { data } = await axios.post(`student/startexam`, cbtDataBody);
        if (!data.status) {
          console.log(data);
          setFetchError(data.message);
          return;
        } else {
          console.log(data.data);
          setQuestionsLength(data.data);
          dataContext.setExamQuestions(data.data);
          localStorage.setItem("examQuestions", JSON.stringify(data.data));
        }
      } catch (error) {
        console.log("get cbt question error", error);
      }
    };
    getCbtExamQuestions();
  }, []);

  const handleStartTest = () => {
    fetchError
      ? alert(`${fetchError}, Please try again later`)
      : window.location.href === "https://demo.edves.net/students/test" ||
        window.location.href === "http://localhost:3001/students/test"
      ? history.push("/ongoingtest2")
      : history.push("/ongoingtest");
    localStorage.removeItem("minutes");
    localStorage.removeItem("answeredQsts");
  };

  const ongoingTest = JSON.parse(localStorage.getItem("clickedCbtItem"));
  //dataContext.examQuestions && dataContext.examQuestions.length === 1 ? '1 Question' :  dataContext.examQuestions.length `Questions`
  return (
    <>
      <TestNav handleStartTest={handleStartTest} />
      {showMenu && (
        <div className="-mt-8 absolute">
          <Sidebar />
        </div>
      )}
      <div
        onClick={() => dataContext.setShowMenu(false)}
        className="flex w-full mt-24 mb-16 sm:mb-0"
      >
        <div className="mx-4 lg:mx-64 md:mx-32 sm:mx-24">
          <div className="sm:h-auto border-0 rounded-xl sm:rounded-2xl bg-blue-100 pt-4 pl-4 sm:pt-8 sm:pl-8">
            <span className="block text-sm leading-4 sm:text-xl sm:leading-6 text-white sm:mt-4">
              {" "}
              You are about to start a test{" "}
            </span>
            <div className="flex w-full h-full">
              <div className="h-full flex-col w-2/3 sm:w-1/2 mt-4 sm:mt-0">
                <div className="flex-col h-full sm:mt-12">
                  <span className="flex mb-5">
                    <AgricSvg />
                    <span className="ml-3 text-xs text-white font-semibold">
                      {" "}
                      {toTitleCase(ongoingTest.subjectname)}{" "}
                    </span>
                  </span>
                  {/* <span className='flex mb-5'>
                                        <QuestionsSvg />
                                        <span className='ml-3 text-xs text-white font-semibold'> {questionsLength ? questionsLength.length === 1 ? '1 Question' :  questionsLength.length `Questions` : ''} </span>
                                    </span> */}
                  <span className="flex mb-5">
                    <TimeSvg />
                    <span className="ml-3 text-xs text-white font-semibold">
                      {" "}
                      {ongoingTest.duration} Mins{" "}
                    </span>
                  </span>
                </div>
              </div>
              <div className="pt-0 ml-0 sm:ml-0 sm:pt-0  sm:w-1/2 h-40 sm:h-full mt-auto rounded-xl sm:rounded-2xl">
                <img
                  src={testImg}
                  alt="test image"
                  className="w-full h-full sm:h-auto rounded-xl sm:rounded-2xl object-cover"
                />
              </div>
            </div>
          </div>
          <div className="mt-12 pb-6">
            <Card>
              <div className="p-4 border-b border-gray-600">
                <span className="text-sm text-gray-200 font-bold leading-5">
                  Carefully go through these Instructions
                </span>
              </div>
              <div className="w-full pb-6 relative">
                <div className="flex items-center px-4 mt-5">
                  <span className="testBulletpt flex-shrink-0 bg-blue-100 rounded-full" />
                  <span className="inline-block text-xs sm:text-sm text-gray-200 leading-5 ml-3 font-medium">
                    The time allocated to this examination is shown at the right
                    side of your screen. You are advised to allocate your time
                    accordingly. Your answer to a question may be submitted at
                    any time before the due time.
                  </span>
                </div>
                <div className="flex items-center px-4 mt-5">
                  <span className="testBulletpt flex-shrink-0 bg-blue-100 rounded-full" />
                  <span className="text-xs sm:text-sm text-gray-200 leading-5 ml-3 font-medium">
                    In attempting this examination and submitting an answer,
                    candidates are undertaking that the work they submit is a
                    result of their own unaided efforts and that they have not
                    discussed the questions or possible answers with other
                    persons during the examination period.
                  </span>
                </div>
                <div className="flex items-center px-4 mt-5">
                  <span className="testBulletpt flex-shrink-0 bg-blue-100 rounded-full" />
                  <span className="text-xs sm:text-sm text-gray-200 leading-5 ml-3 font-medium">
                    Candidates who are found to have participated in any form of
                    cooperation or collusion or any related activity will be
                    viewed as engaging in academic misconduct.
                  </span>
                </div>
                {/* <div className='flex items-center px-4 mt-5'>
                                    <span className='testBulletpt flex-shrink-0 bg-blue-100 rounded-full' />
                                    <span className='text-xs sm:text-sm text-gray-200 leading-5 ml-3 font-medium'>
                                        Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
                                    </span>
                                </div> */}
              </div>
            </Card>
          </div>
          <div className="flex w-full justify-center mt-3 mb-6">
            <Button text="Start Test" onClick={handleStartTest} />
          </div>
        </div>
      </div>
      <div className="w-full sm:hidden z-10 fixed flex justify-between left-0 bottom-0">
        <FooterNav />
      </div>
    </>
  );
};

export default CbtTest;
